import { render, staticRenderFns } from "./shortMessage.vue?vue&type=template&id=2b9d3a8e&scoped=true&"
import script from "./shortMessage.vue?vue&type=script&lang=js&"
export * from "./shortMessage.vue?vue&type=script&lang=js&"
import style0 from "./shortMessage.vue?vue&type=style&index=0&id=2b9d3a8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9d3a8e",
  null
  
)

export default component.exports